export default "/fcbcac1db17390110677298f9d30eeed9c121039/ce82aae38e929df8fcdd7e760ce92d73.svg";